import angular from 'angular'
import template from './template.html'

angular.module('nominas.nomina')
  .component('nominasNominaColaboradoresAgregarIndividual', {
    template: template,
    controller: NominasNominaColaboradoresAgregarIndividualComponent,
    bindings: {
      idEmpresa: '<',
      idNomina: '<',
      indice: '<',
      onChange: '&',
    },
  })

function NominasNominaColaboradoresAgregarIndividualComponent(NominasNominaMovimientosEmpleados, $filter) {
  let $ctrl = this,
    orderBy = $filter('orderBy')
  $ctrl.$onInit = $onInit

  function $onInit() {
    $ctrl.empleados = undefined
    $ctrl.data = undefined

    return NominasNominaMovimientosEmpleados.get($ctrl.idEmpresa, $ctrl.idNomina)
      .then(function (response) {
        $ctrl.empleados = orderBy(response.data.filter(function (item) {
          return ($ctrl.indice || []).indexOf(item.id_empleado + '@' + item.id_empresa) < 0
        }), 'empleado')
      })
  }
}



// WEBPACK FOOTER //
// ./src/nominas/nomina/components/colaboradores/agregar/individual/component.js